import { render, staticRenderFns } from "./ReportPageviews.vue?vue&type=template&id=0b32c70a&scoped=true&"
import script from "./ReportPageviews.vue?vue&type=script&lang=js&"
export * from "./ReportPageviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b32c70a",
  null
  
)

export default component.exports